import toastr from "toastr";

export function showNotification(message, title = '', type = 'success') {
    toastr.options.timeOut = 6000;
    toastr.options.preventDuplicates = false;
    toastr.options.preventOpenDuplicates = true;
    toastr.options.progressBar = true;
    toastr[type](message, title)
}
